import { useQuery } from "@tanstack/react-query";

export interface CustomVoiceEntry {
    /** "custom" for one's own clone, else "custom:<practitionerProfileId>". */
    value: string;
    /** Select label, e.g. "Your voice" / "Laura's Voice". */
    label: string;
    /** Tile label, e.g. "You" / "Laura". */
    shortLabel: string;
    ownedBySelf: boolean;
    practitionerId: string | null;
}

export interface RequestableVoiceEntry {
    practitionerId: string;
    shortLabel: string;
    requested: boolean;
}

interface CustomVoiceResponse {
    voices: CustomVoiceEntry[];
    requestable: RequestableVoiceEntry[];
    // Legacy mirror of the first entry — tolerated while older bundles are in flight.
    available: boolean;
    value: string;
    label: string | null;
}

// AIDEV-NOTE: Which custom (cloned) voices apply to the current account — the
// practitioner's own ready clone, and/or one per active practitioner who has one.
// The picker injects them ahead of the catalog voices.
export function useMeditationCustomVoice({
    enabled = true,
}: { enabled?: boolean } = {}) {
    return useQuery<CustomVoiceResponse>({
        queryKey: ["meditation-custom-voice"],
        enabled,
        staleTime: 60_000,
        retry: false,
        queryFn: async () => {
            const response = await fetch("/api/meditation/custom-voice", {
                credentials: "include",
            });
            if (!response.ok) {
                throw new Error(
                    `custom-voice probe failed: ${response.status}`,
                );
            }
            return (await response.json()) as CustomVoiceResponse;
        },
    });
}
